export default __webpack_public_path__ + "cf391ef3193dd9fbe709fecc09bc10ff.svg";